import { Link } from "react-router-dom";
import { Heart, Zap, Shield, Users, Sparkles } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";

export default function About() {
    return (
        <div className="min-h-screen">
            <PublicHeader />

            <section className="pt-32 pb-12 sm:pt-44 sm:pb-16 px-6 sm:px-8 text-center">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#86868B] mb-3 tk-rise">À propos</p>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#1D1D1F] tk-rise tk-rise-1 leading-[1.05]">
                    On construit l&apos;outil<br />
                    <span className="bg-gradient-to-r from-[#007AFF] to-[#34C759] bg-clip-text text-transparent">
                        qu&apos;on aurait voulu avoir.
                    </span>
                </h1>
                <p className="mt-6 max-w-2xl mx-auto text-lg text-[#86868B] leading-relaxed tk-rise tk-rise-2">
                    Ticketify est né d&apos;une frustration partagée par tous les indépendants et patrons français&nbsp;:
                    passer des heures à chercher des justificatifs au lieu de bosser.
                </p>
            </section>

            <section className="px-6 sm:px-8 pb-20">
                <div className="max-w-3xl mx-auto tk-card p-8 sm:p-10">
                    <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#1D1D1F]">Notre mission</h2>
                    <p className="mt-4 text-[15px] leading-relaxed text-[#1D1D1F]/90">
                        Rendre la conformité comptable invisible. Plus aucun ticket perdu, plus aucune TVA oubliée,
                        plus aucune heure passée à reconstituer une facture pour le comptable.
                    </p>
                    <p className="mt-3 text-[15px] leading-relaxed text-[#1D1D1F]/90">
                        On automatise tout ce qui est automatisable. Pour le reste — les tickets papier qui sortent
                        encore des TPE de quartier — l&apos;IA OCR fait le travail en 7 secondes au lieu d&apos;une
                        heure de saisie.
                    </p>
                </div>
            </section>

            <section className="px-6 sm:px-8 pb-20">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl font-semibold tracking-tight text-[#1D1D1F] text-center mb-12">
                        Nos principes
                    </h2>
                    <div className="grid md:grid-cols-3 gap-5">
                        <Principle
                            icon={Zap}
                            title="Concret"
                            body="Pas de promesse marketing. On dit ce qu'on automatise vraiment, et ce qu'il faut faire à la main."
                        />
                        <Principle
                            icon={Shield}
                            title="Souverain"
                            body="Données hébergées en France, chiffrées, conformes RGPD. Pas de transfert hors UE non consenti."
                        />
                        <Principle
                            icon={Heart}
                            title="Premium par défaut"
                            body="L'UI est aussi soignée que les outils que vous aimez. Parce qu'on l'utilise tous les jours."
                        />
                    </div>
                </div>
            </section>

            <section className="px-6 sm:px-8 py-24">
                <div className="max-w-3xl mx-auto text-center">
                    <Users className="w-10 h-10 text-[#86868B] mx-auto mb-4" />
                    <h2 className="text-3xl font-semibold tracking-tight text-[#1D1D1F]">Pour qui&nbsp;?</h2>
                    <p className="mt-4 text-[15px] text-[#86868B] leading-relaxed">
                        Freelances, dirigeants de TPE/PME, consultants, agences digitales, restaurateurs,
                        professions libérales. Toute personne qui paye par carte pro et veut une compta propre
                        sans y consacrer une heure par semaine.
                    </p>
                    <Link
                        to="/register"
                        className="tk-btn tk-btn-primary mt-8 inline-flex tk-cta-glow"
                        data-testid="about-cta"
                    >
                        <Sparkles className="w-4 h-4" /> Essayer gratuitement
                    </Link>
                </div>
            </section>

            <footer className="border-t border-black/5 py-10 px-6 sm:px-8 text-center text-sm text-[#86868B]">
                © 2026 Ticketify
            </footer>
        </div>
    );
}

function Principle({ icon: Icon, title, body }) {
    return (
        <div className="tk-card p-6 tk-rise">
            <div className="w-11 h-11 rounded-2xl bg-[#F5F5F7] border border-black/5 flex items-center justify-center mb-4">
                <Icon className="w-5 h-5 text-[#1D1D1F]" />
            </div>
            <h3 className="text-lg font-semibold text-[#1D1D1F]">{title}</h3>
            <p className="mt-2 text-sm text-[#86868B] leading-relaxed">{body}</p>
        </div>
    );
}
